import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { lastValueFrom } from "rxjs";
import { applySearchRule } from "../../../../@core/utils/search-input-helper";
import { CustomEntityColumnSchema, CustomEntitySchema, Operator } from "../../../../generated/generated-types";
import { GenericBaseModelDropDown } from "../../../../shared/components/genericBaseModelDropDown";
import { CustomEntityColumnSchemaService } from "../../services/custom-entity-column-schema.service";
import { CustomEntitySchemaService } from "../../services/custom-entity-schema.service";

@Component({
  selector: 'app-custom-entity-column-drop-down',
  standalone: true,
  imports: [],
  template: `
<!-- <ng-template #itemTemplate let-item>
  {{ item.displayName ?? (relationMode ? item.relatedPropertyName : item.identifier) ?? item }}
</ng-template>
<ng-template #selectedItemTemplate let-item>
  {{ item.displayName ?? (relationMode ? (getItemByRelatedPropertyName(item)?.displayName??item) : item.relatedPropertyName) }}
</ng-template> -->
`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomEntityColumnDropDownComponent extends GenericBaseModelDropDown<CustomEntityColumnSchema> {
  @Input()
  entitySchemaId: string;

  @Input()
  blacklistColumnIdentifier: string;

  // @Input()
  // manyToOneRelationsOnly: boolean;

  @Input()
  relationMode: boolean = false;

  relatedEntity: CustomEntitySchema;

  constructor(
    private colService: CustomEntityColumnSchemaService,
    private entityService: CustomEntitySchemaService,
  ) {
    super(colService, "CustomEntityColumnSchema");
    this.autoloadItems.set(true);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.props?.blacklistColumnIdentifier)
      this.blacklistColumnIdentifier = this.props.blacklistColumnIdentifier;
    else if (this.formState?.detailComponent?.origModel?.id && this.formState?.detailComponent?.origModel?.identifier)
      this.blacklistColumnIdentifier = this.formState.detailComponent.origModel?.identifier;

    if (this.props?.entitySchemaId)
      this.entitySchemaId = this.props.entitySchemaId;
    else if (this.model?.entitySchemaId)
      this.entitySchemaId = this.model.entitySchemaId;

    // if (this.props?.manyToOneRelationsOnly !== undefined && this.props?.manyToOneRelationsOnly !== null)
    //   this.manyToOneRelationsOnly = this.props.manyToOneRelationsOnly;

    if (this.props?.relationMode !== undefined && this.props?.relationMode !== null) {
      this.relationMode = this.props.relationMode;
    }

    if (this.relationMode) {
      this.optionLabelSig.set("relatedPropertyName");
      this.optionValueSig.set("relatedPropertyName");

      // this.formControl.setValue(this.model?.relatedPropertyName);
      if (this.initialFetchExecuted)
        this.refresh();
    }
    // else
    //   this.formControl.setValue(this.model[this.field.key as string]);
  }

  override async refresh() {
    if (await this.ensureFilter()) {
      let items = await super.refresh();

      //this is the substitute for the search rule not working:
      if (this.blacklistColumnIdentifier && items.some(x => (x as CustomEntityColumnSchema).requiredFieldIdentifier == this.blacklistColumnIdentifier))
        items = items.filter(y => !('items' in y) && y.requiredFieldIdentifier != this.blacklistColumnIdentifier) as CustomEntityColumnSchema[];

      //if this filter is not applied the items contain items that are not relations
      if (this.relationMode && items.some(x => (x as CustomEntityColumnSchema).type != "relation" || (x as CustomEntityColumnSchema).eagerRelation || (x as CustomEntityColumnSchema).relationType != "ManyToOne"))
        items = items.filter(y => !('items' in y) && (y as CustomEntityColumnSchema).type == "relation" && !(y as CustomEntityColumnSchema).eagerRelation && (y as CustomEntityColumnSchema).relationType == "ManyToOne") as CustomEntityColumnSchema[];

      // if (this.si.term?.length)
      //   items = items.filter(y =>
      //     y.identifier.toLowerCase().indexOf(this.si.term.toLowerCase()) > -1 ||
      //     (y.displayName?.toLowerCase()?.indexOf(this.si.term.toLowerCase()) ?? -1) > -1
      //   );

      this.phxSelectComponent.items.set(items);
      return items;
    }
    else
      return [];
  }

  async ensureFilter() {
    if (!this.entitySchemaId)
      return false;

    if (this.blacklistColumnIdentifier) {
      applySearchRule(this.si, {
        field: "identifier",
        operator: Operator.notequal,
        value: this.blacklistColumnIdentifier
        // operator: Operator.notin,
        // value: JSON.stringify([this.blacklistColumnId])
      });
      //since requiredFieldId is nullable, we need to check if it is null, but i cant get it to work:
      // applySearchRule(this.si, {
      //     field: 'requiredFieldId',
      //     operator: Operator.notequal,
      //     value: this.blacklistColumnId,
      // });
    }

    if (this.relationMode) {
      if (!this.model?.relatedToEntity)
        return false;

      if (!this.relatedEntity || this.relatedEntity.identifier != this.model?.relatedToEntity)
        this.relatedEntity = (await lastValueFrom(this.entityService.getItemByIdentifier(this.model?.relatedToEntity)?.single$))?.getCustomEntitySchemaByIdentifier;
      applySearchRule(this.si, {
        field: "entitySchemaId",
        operator: Operator.equal,
        value: this.relatedEntity.id
      });
      applySearchRule(this.si, {
        field: "eagerRelation",
        operator: Operator.equal,
        value: "false"
      });
      applySearchRule(this.si, {
        field: "type",
        operator: Operator.equal,
        value: "relation"
      });
    }
    else if (this.entitySchemaId)
      applySearchRule(this.si, {
        field: "entitySchemaId",
        operator: Operator.equal,
        value: this.entitySchemaId,
      });

    return true;
  }

  getItemByRelatedPropertyName(value: any) {
    return this.phxSelectComponent?.items()?.find(x => (x as CustomEntityColumnSchema).relatedPropertyName == value);
  }
}

